import { createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#example2" }),
  /*#__PURE__*/_createTextVNode(" Validating fields with yup ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" yup is a very popular, simple and powerful data validation library for JavaScript, you can use it in combination with vee-validate, You can use "),
  /*#__PURE__*/_createVNode("b", null, "yup"),
  /*#__PURE__*/_createTextVNode(" to define your validation rules for that field: ")
], -1)
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = { class: "text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter2 = _resolveComponent("CodeHighlighter2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
          type: "text",
          class: "form-control form-control-solid",
          id: "example1VeeValidate",
          placeholder: "Interact with this field"
        }, null, 512), [
          [_vModelText, _ctx.value]
        ]),
        _createVNode("span", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1),
        _createVNode(_component_CodeHighlighter2, null, {
          html: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.example2Html), 1)
          ]),
          js: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.example2Js), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}